import React, { useEffect, useState } from "react";
import MembershipCard from "./MembershipCard";
import MembershipModal from "../Modal/MembershipDetailsModal";
import { getMembershipFromUsers } from "../../services/firestore/userService";

export default function MembershipCardList({ userData }) {
  const [selected, setSelected] = useState(null);
  const [memberships, setMemberships] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userData?.uid) return;

    const fetchMemberships = async () => {
      try {
        setLoading(true);
        const membershipData = await getMembershipFromUsers(userData.uid);
        setMemberships(membershipData);
      } catch (err) {
        console.error("Error loading memberships:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMemberships();
  }, [userData]);

  if (loading) {
    return (
      <div className="text-center text-gray-500 py-6">Loading memberships...</div>
    );
  }

  if (!memberships.length) {
    return (
      <div className="text-center text-gray-500 py-6">
        No memberships found.
      </div>
    );
  }

  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
      {memberships.map((m, i) => (
        <MembershipCard key={i} membership={m} onClick={() => setSelected(m)} />
      ))}

      {selected && (
        <MembershipModal
          membership={selected}
          onClose={() => setSelected(null)}
        />
      )}
    </div>
  );
}
